import { render, staticRenderFns } from "./DashboardPillarTile.vue?vue&type=template&id=41d20cc4&scoped=true&lang=html&"
import script from "./DashboardPillarTile.vue?vue&type=script&lang=js&"
export * from "./DashboardPillarTile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPillarTile.vue?vue&type=style&index=0&id=41d20cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d20cc4",
  null
  
)

export default component.exports